// import { createTheme } from "@mui/material/styles";
// import { store } from "../../Redux/store";

// export const lightTheme = createTheme({
//   palette: {
//     mode: "light",
//     spacing: 8,
//     background: {
//       assingnedToYouBg: "#F0F0F0",
//       teacherGuidedTag: "#C8DFF9",
//       trackerCtaBG: "#F2F7F7",
//       mentorHomeBackground: "#FCF9F8",
//       studentHomeBackground: "#fffff",
//       studentProgressBg: "#FFF",
//       scholarClubBg: "linear-gradient(96.44deg, #FFF6EB 0%, #FFFBEB 100%)",
//       earnPointBg: "#FFECD7",
//       doubtBannerBG: "linear-gradient(90deg, #F6DFE6 32%, #FAFDF8 100%)",
//       noahCardRoot: "linear-gradient(260.47deg, #F6DFE6 6.59%, #FAFCF7 57.13%)",
//       sectionTopicsCardBackground: "#F2F8F8",
//       fmbg: "#E6E6E6",
//       proTips: "#ffffff",
//       languageSelectorBg: "#FFF",
//       fileNameRootbg: "#FAFAFA",
//       workBenchBg: "#F2F2F2",
//       background0: "#FFFFFF",
//       background1: "#FCF9F8",
//       background2: "#FFFFFF",
//       background3: "#FFFFFF",
//       background4: "#EDF6FC",
//       background5: "#F6F2FC",
//       background6: "#FFF7EB",
//       background7: "#FAFBFF",
//       background8: "#FFFFFF",
//       background9: "#F5F8FF",
//       background10: "linear-gradient(95.18deg, #49FDA9 0%, #38E689 100%)",
//       background11: "linear-gradient(95.18deg, #F8D64F 0%, #DEBF68 100%)",
//       background12: "linear-gradient(95.18deg, #F8D64F 0%, #DEBF68 100%)",
//       background30: "#F2F8F8",
//       background31: "#F1F9F9",
//       background22: "#FDF6ED",
//       codeEditorBackground: "#FFFFFF",
//       assignedToYou: "#FFFAF5",
//       loaderClsbg: "#F1F5F6",
//       completed: "linear-gradient(104deg, #FBFFFA -0.88%, #FAFFFA 102.19%)",
//       assessmentBg: "#E2EFFD",
//       completedSpan: "#DBF0EF",
//       locked: "linear-gradient(95.18deg, #C58A8A 0%, #634040 100%)",
//       activeBtn: "#596DB1",
//       tabBtnBg: "#FBFCFE",
//       codingclscardbg: "#FFE7DB",
//       worksheetclscardbg: "#FFF0C7",
//       runBtnBg: "#25B143",
//       startBtnBg: "#FF712D",
//       InputOutputToggleEditorBtn: "#FF702D",
//       highlightBackground: "#FFF1EB",
//       activeToggleClr: "#000000 !important",
//       inActiveToggleClr: "#808080 !important",
//       activeToglleBg: "#FFFFFF !important",
//       inActiveToggleBg: "#E6E6E6 !important",
//       roleBackground: "#FFF6EB",
//       profileBackground: "#FFFFFF",
//       stepperBg: "#E5F0F0",
//       greenBackground:
//         "linear-gradient(103.97deg, #FBFFFA -0.88%, #FAFFFA 102.19%)",
//       learningPopUpSubject: "#FFFFFF",
//       searchBackground: "#F2F8F8",
//       profileBackgroundCompleted: "#FAFFFA",
//       toggleBg: "#FFEBC2",
//       homeWorkbenchbackground: "#EDF6FC",
//       homeWhiteboardbackground: "#F6F2FC",
//       homeexercisebackground: "#FFF7EB",
//       workbenchFileNameRoot: "#FBFCFE",
//       workbenchFileNameContainer: "#FFFFFF",
//       wrkbchname: "#FBFCFE",
//       workbenchFileNameContainer: "#FBFCFE",
//       filenmrt: "#FBFCFE",
//       filetreebg: "#FFFFFF",
//       fileCollectionClsBg: "#FFFFFF",
//       codngimgclsbg: "#FFD6C2",
//       mathsimgclsbg: "#FFE6A3",
//       codingskillclsbg: "#FFD6C2",
//       mathsskillclsbg: "#FFE399",
//       resultBoxBg: "#EBEFFF",
//       exerciseTabBg: "#ffffff",
//       published: "#3AE98D",
//       fileBody: "#e0e0e0",
//       learningCardEmptyStateBackground:
//         "linear-gradient(90deg, rgba(255,255,255,1) 24%, rgba(253,236,216,1) 100%)",
//     },
//     //border colours
//     border2: "#FDF1ED",
//     border3: "#FDF1ED",
//     border4: "#E3F1FC",
//     border5: "#F3EDFD",
//     border6: "#FBEEDA",
//     exerciseTabBorder: "#E6E6E6",
//     languageSelectorBorder: "1px solid #E6E6E6",
//     studentProgressBorder: "1px solid #FDF1ED",
//     mentorDbLeftRoot: "1px solid #FDF1ED",
//     borderTopicsCard: "#F0F0F0",
//     borderExerciseCompleted: "#B8E0DB",
//     profileBorder: "#EAECF3",
//     dateAndMonth: "#446C6C",
//     workbenchFileNameContainer: "1px solid #EAECF3",
//     InputOutputToggleEditorBtnBorder: "1px solid #FF702D",

//     //border style
//     border7: "1px solid #F0F0F0",
//     border8: "1px solid #EAECF3",
//     dividerbackground: "#0000001f",
//     borderselectLang: "1px solid #7D7D7D",
//     bordereditorborder: "1px solid #E0E0E0",
//     filetreeborder: "1px solid #EAECF3",
//     searchBorder: "#EEEEEE",
//     searchBorderOuter: "#EBF1FF",
//     completedBorder: "#9BD4CD",
//     tabLayoutBorder: "#E6EBF8",
//     btnborder: "1.6px solid #AFCFCF;",

//     //shadows
//     shadow1: "0px 0px 8px rgba(0, 83, 244, 0.16)",
//     completedShadow: "0px 0px 8px 0px rgba(0, 83, 244, 0.16)",
//     tabLayoutShadow: "-4px 0px 8px rgba(0, 0, 0, 0.04)",
//     shadowLearningTopic: "0px 1px 4px 0px #0000001F",

//     // Font colours
//     assingnedToYou: "#7A7A7A",
//     heading: "#2F4F4F",
//     newHeading: "#000000",
//     viewDetailClr: "#95B2B2",
//     inActiveArrow: "#95B2B2",
//     activeArrow: "#2F4F4F",
//     classTimeClr: "#7DA1A1",
//     trackerTextClr: "#8F8F8F",
//     trackerHeading: "#292929",
//     dividerMD: "#EDEAE8",
//     teacherGuidedTagClr: "#31629B",
//     body: "#569090",
//     showingNo: "#569090",
//     sectionText: "#569090",
//     newSectionText: "#808080",
//     highLightTextTopicCard: "#808080",
//     languageselectclr: "#959595",
//     caption: "#95B2B2",
//     caption1: "#FFC247",
//     highlightColor: "#F16118",
//     highlightColor1: "#FFA85D",
//     roleColor: "#A48765",
//     codeEditortxt: "#1E1E1E",
//     menucolor: "#959595",
//     exercise: "#8F8F8F",
//     exerciseCount: "#292929",
//     recentlyOpened: "#2F4F4F",
//     searchText: "#000000",
//     fileText: "#000000",
//     lastOpened: "#B3B3B3",
//     assessment: "#508CCE",
//     level: "#7D7D7D",
//     completed: "#60BDB8",
//     tickSymbol: "#7097FF",
//     exercisePgTitle: "#292929",
//     label: "#8F8F8F",
//     filter: "#525252",
//     filterIcon: "#525252",
//     rowHeading: "#2761BA",
//     trackerHeadings: "#7A7A7A",
//     report: "#666",
//     toggleEditorOutputcolor: "#fff",
//     toggleEditornotOutputcolor: "#FF702D",
//     textareaautosizeClsclr: "#1e1e1e",
//     buttonclr: "2F4F4F",
//     codingskillclsclr: "#CC4300",
//     mathsskillclsclr: "#997000",
//     resultBoxText: "#292929",
//     /******** * */
//     primaryBtnTxt: "#614600",
//     secondaryBtnTxt: "#614600",
//     /****** */
//     secondaryBtnBdr: "1px solid #E6E6E6",
//   },
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 600,
//       md: 960,
//       ipadPro: 1025,
//       lg: 1280,
//       xl: 1920,
//     },
//   },
//   /***********************  */
// });

// export const darkTheme = createTheme({
//   palette: {
//     mode: "dark",
//     spacing: 8,
//     background: {
//       //background colours
//       assingnedToYouBg: "#292929",
//       highlightBackground: "#2E2724",
//       activeToglleBg: "#424242 !important",
//       inActiveToggleBg: "#2A2A2A !important",
//       activeToggleClr: "#FFFFFF !important",
//       inActiveToggleClr: "#808080 !important",
//       mentorHomeBackground: "#0B0A09",
//       studentHomeBackground: "#0B0A09",
//       studentProgressBg: "#1E1E1E",
//       scholarClubBg: "#2E2824",
//       earnPointBg: "#453D36",
//       doubtBannerBG:
//         "linear-gradient(260.47deg, #331F25 6.59%, #1E1E1E 57.13%)",
//       noahCardRoot: "linear-gradient(260.47deg, #331F25 6.59%, #1E1E1E 57.13%)",
//       sectionTopicsCardBackground: "#353231",
//       roleBackground: "#333333",
//       loaderClsbg: "#333333",
//       learningPopUpSubject: "#292929",
//       stepperBg: "#292929",
//       profileBackground: "#1E1E1E",
//       greenBackground: "#1E1E1E",
//       searchBackground: "#1E1E1E",
//       profileBackgroundCompleted: "#1E1E1E",
//       homeWorkbenchbackground: "#2E2824",
//       homeWhiteboardbackground: "#2E2824",
//       homeexercisebackground: "#2E2824",
//       workbenchFileNameRoot: "#1E1E1E",
//       wrkbchname: "#2E2E2E",
//       workbenchFileNameContainer: "#363636",
//       filenmrt: "#292929",
//       filetreebg: "#292929",
//       InputOutputToggleEditorBtn: "#FF702D",
//       fileCollectionClsBg: "#3b3939",
//       codngimgclsbg: "#4C2E2E",
//       mathsimgclsbg: "#4C442E",
//       codingskillclsbg: "#4C2F2F",
//       mathsskillclsbg: "#4C442F",
//       //background colours
//       fmbg: "#363636",
//       proTips: "#363636",
//       languageSelectorBg: "#363636",
//       fileNameRootbg: "#2A2A2A",
//       workBenchBg: "#0B0A09",
//       background0: "#0B0A09",
//       teacherGuidedTag: "#2B323B",
//       trackerCtaBG: "#2E2824",
//       background1: "#0B0A09",
//       background2: "#1E1E1E",
//       background3: "#292929",
//       background4: "#EDF6FC",
//       background5: "#EDF6FC",
//       background6: "#EDF6FC",
//       background7: "#292929",
//       background8: "#333333",
//       background9: "#29323D",
//       background10: "linear-gradient(95.18deg, #02B662 0%, #16B661 100%)",
//       background11: "linear-gradient(95.18deg, #C49E08 0%, #C9952C 100%)",
//       background30: "#1E1E1E",
//       background31: "#292929",
//       background22: "#2E2924",
//       codeEditorBackground: "#363636",
//       assignedToYou: "#1E1E1E",
//       completed: "#1A2221",
//       assessmentBg: "#292929",
//       highlightBackground: "#2E2724",
//       roleBackground: "#333333",
//       codingclscardbg: "#221B1B",
//       worksheetclscardbg: "#22201B",
//       learningCardEmptyStateBackground:
//         "linear-gradient(260.47deg, #2E2824 6.59%, #1E1E1E 57.13%)",

//       completedSpan: "#364543",
//       runBtnBg: "#5CB85C",
//       startBtnBg: "#E98451",
//       toggleBg: "#292929",
//       resultBoxBg: "#3D3D3D",
//       exerciseTabBg: "#2A2A2A",
//       published: "#3AE98D",

//       locked:
//         "linear-gradient(95.18deg, #C58A8A 0%, #A25353 0.01%, #7E4E4E 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
//       activeBtn: "#596DB1",
//       tabBtnBg: "#292929",
//       fileBody: "#2e2e2e",
//     },
//     //border colours
//     border2: "#292929",
//     exerciseTabBorder: "#424242",
//     languageSelectorBorder: "1px solid #424242",
//     studentProgressBorder: "#1E1E1E",
//     border3: "#333333",
//     border4: "#E3F1FC",
//     border5: "#E3F1FC",
//     border6: "#E3F1FC",
//     borderTopicsCard: "#292929",
//     mentorDbLeftRoot: "1px solid #292929",
//     borderExerciseCompleted: "#292929",
//     profileBorder: "#292929",
//     workbenchFileNameContainer: "ipx solid #2E2E2E",
//     bordereditorborder: "1px solid #333333",
//     searchBorder: "#333333",
//     searchBorderOuter: "#333333",
//     completedBorder: "#2B3B39",
//     tabLayoutBorder: "#333333",
//     InputOutputToggleEditorBtnBorder: "1px solid #FF702D",
//     btnborder: "1.6px solid #E98451",
//     //shadows
//     shadow1: "0px 0px 8px 0px #F4000029",
//     completedShadow: "0px 0px 8px 0px #17261A",
//     tabLayoutShadow: "-4px 0px 8px 0px #0000000A",
//     shadowLearningTopic: "0px 1px 4px 0px #0000001F",

//     // Font colours
//     assingnedToYou: "#847871",
//     exercisePgTitle: "#E3E0DE",
//     activeArrow: "#ECEAE9",
//     inActiveArrow: "#847871",
//     heading: "#ECEAE9",
//     newHeading: "#FFFFFF",
//     viewDetailClr: "#847871",
//     classTimeClr: "#847871",
//     trackerTextClr: "#847871",
//     dividerMD: "#292929",
//     trackerHeading: "#ECEAE9",
//     teacherGuidedTagClr: "#D0DFF0",
//     body: "#847871",
//     showingNo: "#ECEAE9",
//     sectionText: "#D0CBC8",
//     newSectionText: "#D0CBC8",
//     highLightTextTopicCard:
//       "linear-gradient(99.24deg, #53B6B6 0%, #54B695 100%)",
//     languageselectclr: "#D0CBC8",
//     caption: "#847871",
//     caption1: "#847871",
//     highlightColor: "#E98451",
//     highlightColor1: "#FFA85D",
//     roleColor: "#847871",
//     dateAndMonth: "#ABA29C",
//     codeEditortxt: "#E0E0E0",
//     borderselectLang: "1px solid #D0CBC8",
//     menucolor: "D0CBC8",
//     textareaautosizeClsclr: "#FFF",
//     // Border style
//     border7: "1px solid #333333",
//     border8: "1px solid #292929",
//     dividerbackground: "#333333",
//     filetreeborder: "1px solid #1E1E1E",
//     guesttrialborder: "1.6px solid #E98451",
//     exercise: "#D0CBC8",
//     exerciseCount: "#ECEAE9",
//     recentlyOpened: "#ECEAE9",
//     searchText: " #D0CBC8",
//     fileText: "#FFFFFF",
//     lastOpened: "#847871",
//     assessment: "#847871",
//     level: "#796E67",
//     completed: "#49AB9E",
//     tickSymbol: "#4AB2AC",
//     label: "#D0CBC8",
//     filter: "#D0CBC8",
//     filterIcon: "#58504B",
//     rowHeading: "#ECEAE9",
//     trackerHeadings: "#ECEAE9",
//     report: "#D0CBC8",
//     codingskillclsclr: "#D4B9B9",
//     mathsskillclsclr: "#C8BFA7",
//     buttonclr: "#E98451",
//     resultBoxText: "#D0CBC8",
//     //****** */
//     primaryBtnTxt: "#614600",
//     secondaryBtnTxt: "#FFC62E",
//     //********* */
//     secondaryBtnBdr: "none",
//   },
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 600,
//       md: 960,
//       ipadPro: 1025,
//       lg: 1280,
//       xl: 1920,
//     },
//   },
// });

// export const getTheme = () => {
//   const isDarkMode = store.getState().darkModeTheme.isDarkModeTheme;
//   if (isDarkMode) {
//     return darkTheme;
//   } else {
//     return lightTheme;
//   }
// };
export const COLORS = {
  // Neutrals
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  GRAY_50: "#FAFAFA",
  GRAY_100: "#F5F5F5",
  GRAY_200: "#F0F0F0",
  GRAY_300: "#E6E6E6",
  GRAY_400: "#BDBDBD",
  GRAY_500: "#808080",
  GRAY_600: "#666666",
  GRAY_700: "#525252",
  GRAY_800: "#424242",
  GRAY_900: "#292929",

  // Specific dark backgrounds
  DARK_BG_PRIMARY: "#0B0A09",
  DARK_BG_SECONDARY: "#1E1E1E",
  DARK_BG_QUATERNARY: "#2E2824",
  DARK_BG_SURFACE: "#333333",
  DARK_BG_CONTENT: "#363636",
  DARK_BG_INPUT: "#2A2A2A",

  // Specific light backgrounds
  LIGHT_BG_SECONDARY: "#FCF9F8",
  LIGHT_BG_SURFACE: "#F2F2F2",
  LIGHT_BG_CONTENT: "#F2F8F8",

  // Blues
  BLUE_LIGHT: "#EDF6FC",
  BLUE_MEDIUM: "#C8DFF9",
  BLUE_DARK: "#508CCE",
  BLUE_LINK: "#2761BA",
  BLUE_SKY: "#F5F8FF",
  BLUE_BORDER: "#E3F1FC",
  BLUE_BLUE_BORDER_LIGHT: "#EBF1FF",
  BLUE_TEACHER_TAG: "#2B323B",

  // Teals
  TEAL_PRIMARY: "#2F4F4F",
  TEAL_SECONDARY: "#569090",
  TEAL_LIGHT: "#95B2B2",
  TEAL_LIGHTER: "#7DA1A1",
  TEAL_BORDER: "#AFCFCF",
  TEAL_BG: "#F2F7F7",
  TEAL_DATE: "#446C6C",
  TEAL_STEPPER: "#E5F0F0",

  // Purples
  PURPLE_LIGHT: "#F6F2FC",
  PURPLE_BORDER: "#F3EDFD",

  // Oranges
  ORANGE_LIGHT: "#FFF7EB",
  ORANGE_LIGHTER: "#FFFAF5",
  ORANGE_MEDIUM: "#FFA85D",
  ORANGE_DARK: "#FF702D",
  ORANGE_DEEP: "#F16118",
  ORANGE_DARK_MODE: "#E98451",
  ORANGE_HIGHLIGHT: "#FFF1EB",
  ORANGE_BORDER: "#FFECD7",
  ORANGE_TOGGLE_BG: "#FFEBC2",
  ORANGE_CODING_LIGHT: "#FFD6C2",
  ORANGE_CODING_CARD: "#FFE7DB",

  // Greens
  GREEN_LIGHT: "#DBF0EF",
  GREEN_MEDIUM: "#60BDB8",
  GREEN_COMPLETED: "#49AB9E",
  GREEN_DARK: "#25B143",
  GREEN_SUCCESS: "#5CB85C",
  GREEN_BRIGHT: "#3AE98D",
  GREEN_TICK: "#4AB2AC",
  GREEN_BORDER: "#9BD4CD",
  GREEN_COMPLETED_BORDER: "#B8E0DB",

  // Yellows
  YELLOW_LIGHT: "#FFF0C7",
  YELLOW_MEDIUM: "#FFC247",
  YELLOW_DARK: "#F8D64F",
  YELLOW_BRIGHT: "#FFC62E",
  YELLOW_MATHS: "#FFE6A3",
  YELLOW_MATHS_SKILL: "#FFE399",

  // Browns
  BROWN_LIGHT: "#A48765",
  BROWN_DARK: "#847871",
  BROWN_MUTED: "#796E67",

  // Pinks
  PINK_LIGHT: "#F6DFE6",

  // Reds
  RED_DARK: "#CC4300",
  RED_LIGHT: "#D4B9B9",

  // Text & Border Colors
  TEXT_DARK_PRIMARY: "#ECEAE9",
  TEXT_DARK_SECONDARY: "#D0CBC8",
  TEXT_HEADING_DARK: "#E3E0DE",

  BORDER_LIGHT_PRIMARY: "#FDF1ED",
  BORDER_LIGHT_TERTIARY: "#EAECF3",

  // Special Colors
  ACTIVE_BTN: "#596DB1",
  DIVIDER_LIGHT: "#EDEAE8",
  TRANSPARENT_BLACK: "#0000001f",
  OFF_WHITE: "#FBFCFE",
  TEACHER_TAG_CLR: "#31629B",
  COMPLETED_BG_DARK: "#1A2221",
  COMPLETED_SPAN_DARK: "#364543",
  COMPLETED_BORDER_DARK: "#2B3B39",
  ORANGE_POINT_DARK: "#453D36",
  RESULTS_BOX_LIGHT: "#EBEFFF",
  RESULTS_BOX_DARK: "#3D3D3D",
  PRIMARY_BTN_TEXT: "#614600",
  CODING_CARD_DARK: "#221B1B",
  WORKSHEET_CARD_DARK: "#22201B",
  FILE_COLLECTION_DARK: "#3b3939",
  CODE_BG_DARK_SECTION: "#353231",
  CODING_IMG_DARK: "#4C2E2E",
  MATHS_IMG_DARK: "#4C442E",
  CODING_SKILL_DARK: "#4C2F2F",
  MATHS_SKILL_DARK: "#4C442F",
  MATHS_SKILL_LIGHT: "#997000",
  FILTER_ICON_DARK: "#58504B",
  WRKBCHNAME_DARK: "#2E2E2E",
};
export const GRADIENTS = {
  GREEN_GRADIENT_LIGHT: "linear-gradient(95.18deg, #49FDA9 0%, #38E689 100%)",
  GREEN_GRADIENT_DARK: "linear-gradient(95.18deg, #02B662 0%, #16B661 100%)",
  YELLOW_GRADIENT_LIGHT: "linear-gradient(95.18deg, #F8D64F 0%, #DEBF68 100%)",
  YELLOW_GRADIENT_DARK: "linear-gradient(95.18deg, #C49E08 0%, #C9952C 100%)",
  SCHOLAR_CLUB_LIGHT: "linear-gradient(96.44deg, #FFF6EB 0%, #FFFBEB 100%)",
  DOUBT_BANNER_LIGHT: "linear-gradient(90deg, #F6DFE6 32%, #FAFDF8 100%)",
  NOAH_CARD_LIGHT: "linear-gradient(260.47deg, #F6DFE6 6.59%, #FAFCF7 57.13%)",
  DOUBT_BANNER_DARK:
    "linear-gradient(260.47deg, #331F25 6.59%, #1E1E1E 57.13%)",
  COMPLETED_GRADIENT:
    "linear-gradient(104deg, #FBFFFA -0.88%, #FAFFFA 102.19%)",
  GREEN_BG_LIGHT: "linear-gradient(103.97deg, #FBFFFA -0.88%, #FAFFFA 102.19%)",
  LOCKED_LIGHT: "linear-gradient(95.18deg, #C58A8A 0%, #634040 100%)",
  LOCKED_DARK:
    "linear-gradient(95.18deg, #C58A8A 0%, #A25353 0.01%, #7E4E4E 100%),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
  HIGHLIGHT_TEXT_DARK: "linear-gradient(99.24deg, #53B6B6 0%, #54B695 100%)",
  LEARNING_CARD_EMPTY_LIGHT:
    "linear-gradient(90deg, rgba(255,255,255,1) 24%, rgba(253,236,216,1) 100%)",
  LEARNING_CARD_EMPTY_DARK:
    "linear-gradient(260.47deg, #2E2824 6.59%, #1E1E1E 57.13%)",
};

// Shadows
export const SHADOWS = {
  LIGHT_SHADOW: "0px 0px 8px rgba(0, 83, 244, 0.16)",
  DARK_SHADOW: "0px 0px 8px 0px #F4000029",
  LEARNING_TOPIC_SHADOW: "0px 1px 4px 0px #0000001F",
  COMPLETED_SHADOW_LIGHT: "0px 0px 8px 0px rgba(0, 83, 244, 0.16)",
  COMPLETED_SHADOW_DARK: "0px 0px 8px 0px #17261A",
  TAB_LAYOUT_SHADOW_LIGHT: "-4px 0px 8px rgba(0, 0, 0, 0.04)",
  TAB_LAYOUT_SHADOW_DARK: "-4px 0px 8px 0px #0000000A",
};

// Toggle values with !important
export const IMPORTANT_VALUES = {
  ACTIVE_TOGGLE_BG_LIGHT: `${COLORS.WHITE} !important`,
  ACTIVE_TOGGLE_BG_DARK: `${COLORS.GRAY_800} !important`,
  INACTIVE_TOGGLE_BG_LIGHT: `${COLORS.GRAY_300} !important`,
  INACTIVE_TOGGLE_BG_DARK: `${COLORS.DARK_BG_INPUT} !important`,
  ACTIVE_TOGGLE_CLR_LIGHT: `${COLORS.BLACK} !important`,
  ACTIVE_TOGGLE_CLR_DARK: `${COLORS.WHITE} !important`,
  INACTIVE_TOGGLE_CLR: `${COLORS.GRAY_500} !important`,
};
